// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b78b4d62","239":"b7d8bd35","455":"68d397d2"}[chunkId] + ".chunk.js";
};